module.exports = "/_next/static/images/logo-2619ebf9d1c1c7e6d6546bdd8146e0c3.png";